// Base URL degli asset statici (avatar e immagini decorative), serviti dal
// repository dam-f/cdn su Cloudflare Pages.
//
// Prima erano 38 URL assolute verso l'host dell'API, compilate nel bundle a
// build time: non derivavano da REACT_APP_APIURL, quindi in disaster recovery
// puntavano a un host inesistente e correggerle richiedeva una rebuild. Una di
// esse puntava per giunta all'host beta, per una copia-incolla mai riallineata.
const cdnBaseUrl = process.env.REACT_APP_CDN_BASEURL;

export default cdnBaseUrl;
